import React, { useState, useRef } from 'react';
import { useEntraAuth } from './EntraAuthProvider';

export const EntraLoginButton = ({ onLoginSuccess, onLoginError, children, disabled = false }) => {
    const { login, loading } = useEntraAuth();
    const [isClicked, setIsClicked] = useState(false);
    const clickTimeoutRef = useRef(null);

    const handleLogin = async () => {
        // Prevent multiple clicks within 3 seconds
        if (disabled || isClicked) return;

        // Set clicked state to prevent rapid clicks
        setIsClicked(true);

        // Clear any existing timeout
        if (clickTimeoutRef.current) {
            clearTimeout(clickTimeoutRef.current);
        }

        // Reset clicked state after 3 seconds
        clickTimeoutRef.current = setTimeout(() => {
            setIsClicked(false);
        }, 3000);

        try {
            // Trigger persistent overlay before starting Microsoft authentication
            if (window.triggerMicrosoftOverlay) {
                window.triggerMicrosoftOverlay();
            }

            // Small delay to ensure overlay is visible before login
            await new Promise(resolve => setTimeout(resolve, 100));

            await login();
            if (onLoginSuccess) {
                onLoginSuccess();
            }
        } catch (error) {
            console.error('Login button error:', error);
            setIsClicked(false); // Reset on error
            if (onLoginError) {
                onLoginError(error);
            }
        }
    };

    const isDisabled = loading || disabled || isClicked;

    return (
        <button
            onClick={handleLogin}
            disabled={isDisabled}
            style={{
                width: '100%',
                padding: '0.75rem',
                background: isDisabled ? '#cccccc' : '#667eea',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                transition: 'background 0.3s',
                opacity: isDisabled ? 0.6 : 1,
            }}
            onMouseOver={(e) => {
                if (!isDisabled) e.target.style.background = '#5a67d8';
            }}
            onMouseOut={(e) => {
                if (!isDisabled) e.target.style.background = '#667eea';
            }}
        >
            {loading || isClicked ? 'Signing in...' : (children || 'Sign In with Microsoft')}
        </button>
    );
};
